import EmergencyOptionId from '@core/constants/EmergencyOption';
import LookingForOptionId from '@core/constants/LookingForOption';
import {
    IFormInputType,
    IFormFieldAdditionalData,
    IFormFieldAdditionalDataKey,
    IBudgetMarks,
} from '../../../interfaces/Form';

interface IAdditionalDataFactory {
    budgetDefaultValue?: number
    budgetMax?: number
    budgetMin?: number
    budgetStep?: number
    hasBudget?: boolean
    hasComment?: boolean
    hasQuantity?: boolean
    hasUpload?: boolean
    marks?: IBudgetMarks
};

export const additionalDataFactory: ((args?: IAdditionalDataFactory) => IFormFieldAdditionalData) = ({
    budgetDefaultValue = 2500,
    budgetMax = 6000,
    budgetMin = 1000,
    budgetStep = 100,
    hasComment = true,
    hasBudget = true,
    hasQuantity = true,
    hasUpload = true,
    marks,
} = {}) => ({
    ...(hasQuantity && {
        [IFormFieldAdditionalDataKey.Quantity]: {
            value : undefined,
            min   : 1,
            max   : 10,
        },
    }),
    [IFormFieldAdditionalDataKey.IsPrivate]: {
        value: undefined,
    },
    [IFormFieldAdditionalDataKey.LookingFor]: {
        value   : undefined,
        options : [
            LookingForOptionId.Serious,
            LookingForOptionId.BankQuote,
            LookingForOptionId.Curious,
        ],
        required: true,
    },
    [IFormFieldAdditionalDataKey.Emergency]: {
        value   : undefined,
        options : [
            EmergencyOptionId.ThreeMonth,
            EmergencyOptionId.SixMonth,
            EmergencyOptionId.MoreSixMonth,
        ],
        required: true,
    },
    ...(hasBudget && {
        [IFormFieldAdditionalDataKey.Budget]: {
            value : undefined,
            type  : IFormInputType.Range,
            marks : marks || undefined,
            step  : marks ? null : budgetStep,
            range : {
                min : budgetMin,
                max : budgetMax,
            },
            defaultValue : budgetDefaultValue,
            required     : true,
        },
    }),
    ...(hasComment && {
        [IFormFieldAdditionalDataKey.Comment]: {
            value    : undefined,
            required : false,
        },
    }),
    ...(hasUpload && {
        [IFormFieldAdditionalDataKey.UploadFile]: {
            value    : undefined,
            required : false,
        },
    }),
});

export default additionalDataFactory;
